<template>
  <div class="vchat" v-if="showChat" >
      <div class="vchat__header">
        <img  src="/favicon-32x32.png"  class="vchat__header-logo">
        <p class="mg-t-auto mg-b-auto color_white typography typography_size_title-1 typography_family_semi">{{brandName}} {{$t('chat.header')}}</p>
        <button class="vchat__header-close" @click="close">
          <svg class="vchat__header-close-icon" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="icons" stroke="none" fill="none"><g id="icon_close" fill="#55555D"><path d="M6.707 5.293L12 10.585l5.293-5.292a1 1 0 011.414 1.414L13.415 12l5.292 5.293a1 1 0 01-1.414 1.414L12 13.415l-5.293 5.292a1 1 0 11-1.414-1.414L10.585 12 5.293 6.707a1 1 0 011.414-1.414z" id="icon"></path></g></g>
          </svg>
        </button>
      </div>
      <div class="vchat__body" ref="chatBody">
        <div class="vchat__conversation" ref="chatConversation" id="chatConversation">
          <div class="vchat__conversation_time-day">{{firstConversationTime}} </div>
          <div v-if="showGreetingMessage" class="vchat__msg-wrapper">
            <div class="vchat__msg-avatar mg-t-auto">
              <img src="/src/assets/images/assistant_logo.svg" width="25" height="25">
            </div>
            <div class="vchat__msg-content">
              <div>
                <p>{{$t('chat.welcom_1')}} {{brandName}} {{$t('chat.welcom_2')}} 🤓</p>
                <p>
                  {{$t('chat.iam')}}
                </p>
                <p>{{$t('chat.letsstart')}} 😉</p>
              </div>
            </div>
          </div>

          <div class="vchat__msg-wrapper" v-bind:class="{ 'vchat__msg-owner': data && data.from_me }"   v-for="(data, key) in getChatMessageList" :key="key">
            <div class="vchat__msg-avatar mg-t-auto"  v-if="!data.from_me">
              <img src="/src/assets/images/assistant_logo.svg" width="25" height="25">
            </div>
            <div class="vchat__msg-content">
              <div v-html="processedMessage(data.message)"></div>
            </div>
            <div class="vchat__msg-additional">
              <div class="mg-t-auto">

                <div class="vchat__msg-status-icon" v-bind:class="{ 'read': data.read }">
                  <span v-if="!data.from_me && !data.read">
                    {{setReadMessage(data.id)}}
                  </span>
                </div>
                <div class="vchat__msg-date">
                  {{ data.date }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="showLoginMessage" class="vchat__msg-wrapper">
            <div class="vchat__msg-avatar mg-t-auto">
              <img src="/src/assets/images/assistant_logo.svg" width="25" height="25">
            </div>
            <div class="vchat__msg-content">
              <div>
                <p>{{$t('chat.message_login_1')}}</p>
                <p>{{$t('chat.message_login_2')}}</p>
                <p class="color_white" style="font-size: 10px">
                  <vRouterLink to="/login" class="c-btn_signin  color_dark"
                               style="white-space: nowrap; font-size: 9px; background-color: #ffd2b6">{{$t('convert.signin')}}
                  </vRouterLink>
                  {{$t('convert.or')}}
                  <vRouterLink to="/registration" class="c-btn_signin typography  color_dark"
                               style="white-space: nowrap; font-size: 9px; background-color: #ffd2b6">{{$t('convert.reg')}}</vRouterLink>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showWorkArea" class="vchat__footer">
        <label class="vchat__work_attach mg-t-auto mg-b-auto mg-r-1" for="chat-modal-file">
          <svg fill="currentColor" width="20" height="20" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.469 16.688l8.75-8.75c0.094-0.094 0.844-0.844 2.031-1.25 1.656-0.531 3.344-0.094 4.688 1.25 1.375 1.344 1.781 3 1.25 4.656-0.375 1.188-1.156 2-1.25 2.094l-9.406 9.406c-1.625 1.625-5.688 3.719-9.438 0-3.719-3.719-1.594-7.813 0-9.406l10.094-10.125c0.375-0.375 0.969-0.375 1.344 0s0.375 0.969 0 1.344l-10.063 10.125c-0.156 0.125-3.313 3.406 0 6.719 3.219 3.219 6.375 0.344 6.719 0l9.406-9.438s0.531-0.531 0.781-1.281c0.313-1 0.094-1.875-0.781-2.75-1.875-1.875-3.688-0.313-4.031 0l-8.75 8.719c-0.313 0.313-0.531 0.844 0 1.375s1.031 0.281 1.344 0l6.063-6.063c0.375-0.344 1-0.344 1.344 0 0.375 0.375 0.375 1 0 1.375l-6.063 6.031c-0.844 0.813-2.563 1.469-4.031 0-1.5-1.469-0.844-3.219 0-4.031z"></path>
          </svg>
        </label>
        <input class="d-none"  @change="handleSendFile" accept="image/*,.pdf" type="file" id="chat-modal-file">
        <textarea class="vchat__work_input"
                  v-model="message"
                  v-bind:class="{'is-invalid' : hasError('message')}"
                  @keydown.enter="handleSubmit"
                  :placeholder="$t('chat.typeMessage')+'...'"></textarea>
      </div>
  </div>
</template>

<script>

import { ref } from "vue";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import {mapActions, mapGetters} from "vuex";
import vRouterLink from "./base/vRouterLink.vue";

export default {
  name: "vChat",
  components: {vRouterLink},
  props: {
    showChat: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      brandName: import.meta.env.VITE_APP_BRAND_NAME,
      showGreetingMessage: false,
      showLoginMessage: false,
      showWorkArea: false,
      message: '',
      firstStart: true
    };
  },
  emits: ["closeChat"],
  validations () {
    return {
      //message:{required: helpers.withMessage('validation.reqField', required)},
    }
  },
  setup () {
    const serverRunning = typeof window === 'undefined'
    const externalResults = ref({})
    return {
      externalResults,
      v$: serverRunning? null : useVuelidate({ $externalResults: externalResults, clearsExternalResultsOnStateChange: true  })
    }
  },
  watch: {
    showChat(newVal) {
      if (newVal) {
        this.makeShowGreetingMessage()
        this.makeShowLoginMessage()
      }
    },
    message:function (value, oldValue) {
      this.clearValidation('take_profit')
    },
    getChatMessageList: {
      handler(newValue, oldValue) {

        const messagesArray = Object.values(newValue);
        if (messagesArray.length === 0) {
            return;
        }
        const lastMessage = messagesArray.reduce((prev, current) => {
          return (prev.id > current.id) ? prev : current;
        });

        if (lastMessage.from_me === false && !this.firstStart) {
          this.playSoundStart();
        }
        this.showMessage()
        this.firstStart = false
      },
      deep: true,
    },

  },
  computed: {
    ...mapGetters(["getChatMessageList", "getChatNewCount", "getAuthTokens"]),
    firstConversationTime(){
      const key = 'timestamp_lastchat';
      let savedTimestamp = localStorage.getItem(key);

      if (!savedTimestamp) {
        savedTimestamp = new Date().toISOString();
        localStorage.setItem(key, savedTimestamp);
      }

      const date = new Date(savedTimestamp);

      return `${this.$t('calendar.'+(date.getMonth()+1))} ${date.getDate()} ${date.getFullYear()}, ${date.getHours()}:${date.getMinutes()}`
    }
  },
  methods: {
    ...mapActions(["fetchChat", "fetchChatNew", "sendChatMessage"]),
    processedMessage(message) {
      const imageExtensions = /\.(jpg|jpeg|png|gif)$/i;
      return message.replace(/<img\s+src="([^"]+)"[^>]*>/g, (match, src) => {
        const isImage = imageExtensions.test(src);
        const newSrc = isImage ? src : '/file-preview.svg';
        return `<img src="${newSrc}"  style="height: 50px !important;" alt="">`;
      });
    },
    showMessage() {
      const chatBody = this.$refs.chatBody;
      if (chatBody) {
        setTimeout(() => {
          chatBody.scrollTop = chatBody.scrollHeight;
        }, 300);
      }
    },
    makeShowGreetingMessage() {
      this.playSoundStart()
      const that = this
      setTimeout(() => {
        that.showGreetingMessage = true
        that.showMessage()
      }, 400);
    },
    makeShowLoginMessage() {
      if(this.getAuthTokens == null) {
        const that = this
        setTimeout(() => {
          that.showLoginMessage = true
          that.showMessage()
        }, 800);
      } else {
        this.$connect(import.meta.env.VITE_APP_CHAT_SOCKET + "?token=" + this.getAuthTokens.auth_token)
        this.showWorkArea = true
        this.fetchChatNew()
      }
    },
    playSoundStart() {
      const audio = new Audio('/sounds/chat-start.mp3');
      audio.play();
    },
    close() {
      this.$emit('closeChat')
    },
    clearValidation(attr) {
      if(attr !== undefined) {
        if(this.externalResults[attr] !== undefined) {
          delete this.externalResults[attr]
        }
      } else {
        this.externalResults = {}
        this.v$.$reset()
      }
    },
    hasError(attribute) {
      return this.v$ !== null && this.v$[attribute] !== undefined && this.v$[attribute].$dirty &&
          this.v$[attribute].$errors !== undefined && this.v$[attribute].$errors.length
    },

    async handleSendFile(event) {
      const file = event.target.files[0];
      if (!file) {
        this.$toast.error(this.$t("chat.errorFileLoad"), {
          position: 'top-right'
        })
        return;
      }

      if (file.size > 5000000) {
        this.$toast.error(this.$t("chat.errorFileSize") + ' 5MB.', {
          position: 'top-right'
        })
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        const metadata = {
          type: 'at',
          filename: file.name,
        };
        const metadataJson = JSON.stringify(metadata);
        const metadataBuffer = new TextEncoder().encode(metadataJson);

        const combinedBuffer = new Uint8Array(metadataBuffer.byteLength + arrayBuffer.byteLength);
        combinedBuffer.set(new Uint8Array(metadataBuffer), 0);
        combinedBuffer.set(new Uint8Array(arrayBuffer), metadataBuffer.byteLength);

        const blob = new Blob([arrayBuffer], { type: file.type });
        const url = URL.createObjectURL(blob);
        this.sendChatMessage(`<img src="${url}" height="200" alt="">`)
        this.$socket.send(combinedBuffer);

      };

      reader.readAsArrayBuffer(file);
    },
    async handleSubmit(event) {
      if (!event.shiftKey) {
        event.preventDefault();
        if (this.message.trim() === '') {
          this.message += '\n';
          return
        }
        this.clearValidation()
        const isFormCorrect = await this.v$.$validate()
        if (!isFormCorrect) {
          this.loading = false
          return
        }
        this.$socket.sendObj({
          message: this.message,
          type: 'ms'
        });
        this.sendChatMessage(this.message)
        this.message = ''
      }
    },
    setReadMessage(id) {
      this.$socket.sendObj({
        id: id,
        type: 'rd'
      });
    }
  },
  mounted() {
    if(this.showChat) {
      this.makeShowGreetingMessage()
      this.makeShowLoginMessage()
    }
    this.showGreetingMessage = false
    this.showLoginMessage = false
  },
  beforeDestroy() {

  }
}
</script>
